const deleteEquipments = {
  toastr: 'Equipos eliminados',
  toastr1: 'Equipos eliminados con éxito'
};

export default deleteEquipments;
